// extracted by mini-css-extract-plugin
module.exports = {"chip":"ModelDetailPage_chip_30yDi"};